import React from 'react';
import Types from '../../constants/Types';
import ObjectOverride from '../ObjectOverride';
import ModuleCard from './ModuleCard';

class HardwareList extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations_Modules._name);
	}

	render() {

		return (
			<>
				<hr></hr>
				<h4 style={{ fontWeight: 'bold' }}>Hardware</h4>
			</>
		);
	}
}

export default HardwareList;